import { useEffect, useState , useContext} from "react";
import { toast } from "react-toastify";
import AlertModal from "../../../components/dashboard/common/AlertModal";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import {
  funProjectStatus,
  submissionProjects,
} from "../../../service/DashboardService";

import loader from "../../../assets/images/loader.gif";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import ProjectDetailModal from "../../../components/dashboard/admin-dashboard/detail-modal/ProjectDetailModal";
import { getProjectById } from "../../../service/MainService";
import { AppContext } from "../../../context/AppContext";


export default function AllSubmissions() {
  const [openAlert, setOpenAlert] = useState(false);
  const [projectStatus, setProjectStatus] = useState({});
  const { setdataStore, dataStore } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [projectDetail, setProjectDetail] = useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const projectList = await submissionProjects();
        console.log(projectList);
        setdataStore(projectList);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(error.message || "Something went wrong");
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const projectApproval = (projectId) => {
    setProjectStatus({
      ProjectId: projectId,
      ProjectStatus: "APPROVED",
    });
    setOpenAlert(true);
  };
  const projectReject = (projectId) => {
    setProjectStatus({ ProjectId: projectId, ProjectStatus: "REJECTED" });
    setOpenAlert(true);
  };

  const projectStatusUpdate = async () => {
    try {
      const response = await funProjectStatus(projectStatus);
      console.log(response);
      if (response.header.code === 600) {
        toast.success(response.body.value);
        const updatedpendingProjects = dataStore.filter(
          (item) => item.ProjectId !== projectStatus.ProjectId
        );
        setdataStore(updatedpendingProjects);
      } else {
        toast.error(response.body.value);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
    setOpenAlert(false);
  };

  const formatDateTime = (dateTimeString) => {
    const options = {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleDateString("en-US", options);
  };

  const handleViewClick = async (projectId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getProjectById(projectId, token);
      setProjectDetail(response);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  return (
    <>
      <TopHeader />
      {/* <div className="flex items-center gap-4">
        <div className="inline-flex rounded-md shadow-sm mb-10" role="group">
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-gray-900 bg-transparent border border-gray-900 rounded-s-lg hover:bg-gray-900 hover:text-white focus:z-10 focus:ring-2 focus:ring-gray-500 focus:bg-gray-900 focus:text-white dark:border-white dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:bg-gray-700"
          >
            All Notifications
          </button>
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-white  bg-gray-500  border-t border-b border-gray-900 hover:bg-gray-900 hover:text-white focus:z-10 focus:ring-2 focus:ring-gray-500 focus:bg-gray-900 focus:text-white dark:border-white dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:bg-gray-700"
          >
            Requests
          </button>
        </div>
      </div> */}
      <div>
        {loading ? (
          <div className="flex justify-center ">
            <img src={loader} alt="Loading" />
          </div>
        ) : dataStore.length === 0 ? (
          <p colSpan="4" className="text-center py-4">
            No records found
          </p>
        ) : (
          dataStore.map((projects, index) => (
            <ul key={index} className="divide-y divide-gray-100">
              <li className="flex justify-between gap-x-6 px-5 py-5  bg-white p-2 border-b border-gray-600 rounded-md">
                <div className="min-w-0 flex-auto">
                  <h1 className="text-gray-900 font-bold mb-4">
                    {projects.ProjectName}
                  </h1>
                  <p className="mt-1 truncate text-sm leading-5 text-gray-700">
                    {projects?.user?.UserName} Requested for Approval
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <p className="text-sm leading-6 text-gray-900">
                    {formatDateTime(projects.UploadDateTime)}
                  </p>
                  <div className="flex items-center gap-2 mt-2">
                    <span
                      className="text-red-600 cursor-pointer"
                      onClick={() => projectReject(projects.ProjectId)}
                    >
                      Reject
                    </span>
                    <span
                      className="bg-blue-500 text-white text-xs font-bold me-2 px-2.5 py-1.5 rounded-full dark:bg-green-900 dark:text-green-300 cursor-pointer"
                      onClick={() => projectApproval(projects.ProjectId)}
                    >
                      Approval
                    </span>
                    <ListAction
                      onViewClick={() => handleViewClick(projects.ProjectId)}
                      showDeleteButton={false}
                    />
                  </div>
                </div>
              </li>
            </ul>
          ))
        )}
      </div>
      {projectDetail && (
        <ProjectDetailModal
          open={open}
          setOpen={setOpen}
          projectDetail={projectDetail}
        />
      )}
      <AlertModal
        open={openAlert}
        setOpen={setOpenAlert}
        projectStatus={projectStatus}
        statusUpdate={projectStatusUpdate}
      />
    </>
  );
}
